import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { IntegrationIntegrationInterfaceCompanySaveRequest } from '@/main/models/request';
import { IntegrationIntegrationInterfaceCompanySaveResponse } from '@/main/models/response';

export abstract class IIntegrationIntegrationInterfaceCompanyApi {
  abstract getIntegrationinterfaceCompanyData(
    guidIntegrationInterface_Company: string
  ): Promise<AxiosResponse<Result<IntegrationIntegrationInterfaceCompanySaveResponse>>>;

  abstract save(
    request: IntegrationIntegrationInterfaceCompanySaveRequest
  ): Promise<AxiosResponse<Result<IntegrationIntegrationInterfaceCompanySaveResponse>>>;
}